/* 개발망 */

import type { SettingConfigSiteInfo } from './type';

// bktv
export const developmentBktv: SettingConfigSiteInfo = {
  PC_URL: 'https://www.bktv.kr',
  BASE_URL: 'https://www.bktv.kr',
  API_URL: 'api.bktv.kr',
  EVENT_URL: 'https://events.bktv.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
export const mDevelopmentBktv: SettingConfigSiteInfo = {
  PC_URL: 'https://m.bktv.kr',
  BASE_URL: 'https://m.bktv.kr',
  API_URL: 'api.bktv.kr',
  EVENT_URL: 'https://events.bktv.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_MOBILE_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// 상망 api에 연결된 개발망
export const productionDevWwwPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://dev-www.pandalive.co.kr',
  BASE_URL: 'https://dev-www.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
export const mProductionDevWwwPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://dev-www.pandalive.co.kr',
  BASE_URL: 'https://dev-m.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_MOBILE_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// Fanza
export const developmentFanza: SettingConfigSiteInfo = {
  PC_URL: 'http://dev.pandalive.co.jp',
  BASE_URL: 'http://dev.pandalive.co.jp',
  API_URL: 'apidev.pandalive.co.jp',
  EVENT_URL: 'https://events.pandatv.dmm.co.jp',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
};

export const mDevelopmentFanza: SettingConfigSiteInfo = {
  PC_URL: 'http://dev.pandalive.co.jp',
  BASE_URL: 'http://mdev.pandalive.co.jp',
  API_URL: 'apidev.pandalive.co.jp',
  EVENT_URL: 'https://events.pandatv.dmm.co.jp',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
};
